import { Injectable } from "@angular/core";
import { UrlTree, CanLoad, Route, UrlSegment, Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { PersistanceService } from "@shared/services/persistance.service";
import { AuthService } from "@api/auth.service";
import { catchError, map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AuthenticationGuard implements CanLoad {
  constructor(
    private router: Router,
    private persistanceService: PersistanceService,
    private authService: AuthService
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.persistanceService.get("token")) {
      this.persistanceService.logOut();
      return false;
    } else {
      // return true;
      return this.authService.getCheckAuthToken().pipe(
        map(() => {
          // this.router.navigate(['/dashboard'] );
          return true;
        
        }),
        catchError((err) => {
          
          this.persistanceService.logOut();
          return of(false);
        })
      );
    }
  }
}
